// Auto-generated feature flags from Azure App Configuration
// Generated at: 2026-06-08T11:07:13.238Z
// Do not edit this file manually
// Priority order: Custom Label > Global > No Label

export interface FeatureFlag {
  enabled: boolean;
  conditions: Record<string, any>;
  description: string;
  lastModified: string;
}

export interface FeatureFlags {
  readonly aIStudioInPreview: FeatureFlag;
  readonly aIEPSToSvg: FeatureFlag;
  readonly accessibilityWidget: FeatureFlag;
  readonly additionalAttributes: FeatureFlag;
  readonly aiStudio3D: FeatureFlag;
  readonly allowAIToolsForTrialUsers: FeatureFlag;
  readonly backgroundRemoverLegacySelection: FeatureFlag;
  readonly bulkImport: FeatureFlag;
  readonly bulkUnitPrice: FeatureFlag;
  readonly configuratorUrlSwitch: FeatureFlag;
  readonly convertToCurrencyForMasterIntegration: FeatureFlag;
  readonly discoveryMode: FeatureFlag;
  readonly filledText: FeatureFlag;
  readonly iNKSCAPEIMAGECONVERSIONUPLOAD: FeatureFlag;
  readonly interfacePlugins: FeatureFlag;
  readonly jsonProductsImport: FeatureFlag;
  readonly mOQ: FeatureFlag;
  readonly newConfiguratorBackoffice: FeatureFlag;
  readonly newConfiguratorUIEnabled: FeatureFlag;
  readonly newCustomizerMonochromeUI: FeatureFlag;
  readonly orderErrors: FeatureFlag;
  readonly pDFTOSVG: FeatureFlag;
  readonly preview3DCamera: FeatureFlag;
  readonly prototypeMode: FeatureFlag;
  readonly rateLimit: FeatureFlag;
  readonly salesChannelsOnBulk: FeatureFlag;
  readonly shopifyRedactProducts: FeatureFlag;
  readonly standalone: FeatureFlag;
  readonly storageFeature: FeatureFlag;
  readonly svgClipEnabled: FeatureFlag;
  readonly svgConvertTextInOutlinesEnabled: FeatureFlag;
  readonly designwithaibackoffice: FeatureFlag;
  readonly minimumOrderQuantityPriceUi: FeatureFlag;
  readonly switchSalesChannel: FeatureFlag;
}

export const FEATURE_FLAGS: FeatureFlags = {
  aIStudioInPreview: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "299791",
                        "252538"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Abilita AI Studio in Preview prodotto, per poter aprire prodotto in finestra di AI Studio per rapida creazione di immagini varie",
    lastModified: "2026-04-09T12:59:12.000Z"
  },
  aIEPSToSvg: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112",
                        "83318"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2025-11-25T11:49:48.000Z"
  },
  accessibilityWidget: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "Widget a11y",
    lastModified: "2025-10-30T08:57:33.000Z"
  },
  additionalAttributes: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-05-13T12:54:36.000Z"
  },
  aiStudio3D: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-05-13T13:48:17.000Z"
  },
  allowAIToolsForTrialUsers: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-04-28T13:24:57.000Z"
  },
  backgroundRemoverLegacySelection: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-04-02T07:11:11.000Z"
  },
  bulkImport: {
    enabled: false,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 100
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-05-29T09:02:17.000Z"
  },
  bulkUnitPrice: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-08-25T11:25:05.000Z"
  },
  configuratorUrlSwitch: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Se mostrare lo switch per cambiare tra nuovo/vecchio tema configuratore su nuovo BO",
    lastModified: "2026-06-01T14:01:25.000Z"
  },
  convertToCurrencyForMasterIntegration: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "118656",
                        "2112"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "To manage currency conversion (currency mismatch between sales channels - master)",
    lastModified: "2025-11-11T12:21:56.000Z"
  },
  discoveryMode: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "Enable discovery mode for the customizer",
    lastModified: "2026-03-19T09:59:48.000Z"
  },
  filledText: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-11T12:30:13.000Z"
  },
  iNKSCAPEIMAGECONVERSIONUPLOAD: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112",
                        "293714"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-04-27T13:27:10.000Z"
  },
  interfacePlugins: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-12T11:47:11.000Z"
  },
  jsonProductsImport: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112",
                        "280843",
                        "289832",
                        "287909",
                        "288939"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2025-12-19T14:03:48.000Z"
  },
  mOQ: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-05-13T12:54:53.000Z"
  },
  newConfiguratorBackoffice: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "A feature flag for enabling the new configurator backoffice",
    lastModified: "2025-08-28T10:24:02.000Z"
  },
  newConfiguratorUIEnabled: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311399"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "This flag will enable the new UI for configurator products",
    lastModified: "2026-04-17T10:26:53.000Z"
  },
  newCustomizerMonochromeUI: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 100
                }
            }
        }
    ]
},
    description: "Abilita Monochrome UI per maxColors 1",
    lastModified: "2026-02-18T17:02:38.000Z"
  },
  orderErrors: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-10-04T15:27:05.000Z"
  },
  pDFTOSVG: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112",
                        "74692",
                        "35553",
                        "293714"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-04-27T13:58:44.000Z"
  },
  preview3DCamera: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-09T16:14:48.000Z"
  },
  prototypeMode: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "299791",
                        "2112"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-05-07T10:16:35.000Z"
  },
  rateLimit: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-23T09:19:10.000Z"
  },
  salesChannelsOnBulk: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-08-25T08:08:58.000Z"
  },
  shopifyRedactProducts: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-07-01T13:47:52.000Z"
  },
  standalone: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-04T15:37:26.000Z"
  },
  storageFeature: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Is used to show the Storage section ",
    lastModified: "2025-07-21T13:46:11.000Z"
  },
  svgClipEnabled: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "2112",
                        "75997"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2025-11-24T12:41:00.000Z"
  },
  svgConvertTextInOutlinesEnabled: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-10T16:14:28.000Z"
  },
  designwithaibackoffice: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "299791",
                        "252538"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Design with AI disabilitato in BO merchant tranne per utenti specifici",
    lastModified: "2026-04-09T12:59:42.000Z"
  },
  minimumOrderQuantityPriceUi: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311405"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Limitato a testing per demo di kickoff prima dell osviluppo effettivo",
    lastModified: "2026-03-04T12:30:23.000Z"
  },
  switchSalesChannel: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "256709"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "If you active this feature you can enable the possibility of switching of the sales channels",
    lastModified: "2025-11-28T10:04:31.000Z"
  }
} as const;

// Helper function to check if a feature is enabled
export function isFeatureEnabled(flagName: keyof FeatureFlags): boolean {
  return FEATURE_FLAGS[flagName]?.enabled ?? false;
}

// Helper function to get feature flag conditions
export function getFeatureConditions(flagName: keyof FeatureFlags): Record<string, any> {
  return FEATURE_FLAGS[flagName]?.conditions ?? {};
}

// Helper function to check feature with custom conditions
export function isFeatureEnabledWithConditions(
  flagName: keyof FeatureFlags, 
  userContext?: Record<string, any>
): boolean {
  const flag = FEATURE_FLAGS[flagName];
  if (!flag) return false;
  
  if (!flag.enabled) return false;
  
	// If no conditions or user context, return base enabled state
	const hasNoConditions = !flag.conditions || Object.keys(flag.conditions).length === 0;
	const hasEmptyClientFilters =
		flag.conditions?.client_filters && (!Array.isArray(flag.conditions.client_filters) || flag.conditions.client_filters.length === 0);
	const noUserContext = !userContext;

	if (hasNoConditions || hasEmptyClientFilters || noUserContext) {
		return flag.enabled;
	}

    // Handle Azure App Configuration client_filters format
  if (flag.conditions.client_filters && Array.isArray(flag.conditions.client_filters)) {
    for (const filter of flag.conditions.client_filters) {
      // Handle old UserID format
      if (filter.name === 'UserID' && filter.parameters && filter.parameters.userID) {
        const requiredUserId = filter.parameters.userID;
        const userIdFromContext = userContext.userId ? parseInt(userContext.userId) : undefined;
        
        if (userIdFromContext === requiredUserId) {
          return true;
        }
      }
        // Handle new Microsoft.Targeting format
      if (filter.name === 'Microsoft.Targeting' && filter.parameters && filter.parameters.Audience) {
        const audience = filter.parameters.Audience;
        const userIdFromContext = userContext.userId ? userContext.userId.toString() : undefined;
        
        // Check if user is in the Users array
        if (audience.Users && Array.isArray(audience.Users) && userIdFromContext) {
          if (audience.Users.includes(userIdFromContext)) {
            return true;
          }
        }
        
        // TODO: Handle Groups and DefaultRolloutPercentage if needed
      }
        // Handle Env (Environment) filter
      if (filter.name === 'Env' && filter.parameters && filter.parameters.env) {
        const requiredEnv = filter.parameters.env;
        // Check environment from userContext.environment, userContext.env, or NODE_ENV
        const currentEnv = userContext.environment || userContext.env || process.env.NODE_ENV;
        
        if (currentEnv === requiredEnv) {
          return true;
        }
      }
    }
    // If we have client_filters but none matched, return false
    return false;
  }
  
  // Fallback to simple condition evaluation for other formats
  for (const [conditionKey, conditionValue] of Object.entries(flag.conditions)) {
    if (userContext[conditionKey] !== conditionValue) {
      return false;
    }
  }
  
  return true;
}

// Export individual feature flags for direct access
export const AISTUDIO_IN_PREVIEW_FEATURE = FEATURE_FLAGS.aIStudioInPreview;
export const AI_EPS_TO_SVG_FEATURE = FEATURE_FLAGS.aIEPSToSvg;
export const ACCESSIBILITY_WIDGET_FEATURE = FEATURE_FLAGS.accessibilityWidget;
export const ADDITIONAL_ATTRIBUTES_FEATURE = FEATURE_FLAGS.additionalAttributes;
export const AI_STUDIO3D_FEATURE = FEATURE_FLAGS.aiStudio3D;
export const ALLOW_AITOOLS_FOR_TRIAL_USERS_FEATURE = FEATURE_FLAGS.allowAIToolsForTrialUsers;
export const BACKGROUND_REMOVER_LEGACY_SELECTION_FEATURE = FEATURE_FLAGS.backgroundRemoverLegacySelection;
export const BULK_IMPORT_FEATURE = FEATURE_FLAGS.bulkImport;
export const BULK_UNIT_PRICE_FEATURE = FEATURE_FLAGS.bulkUnitPrice;
export const CONFIGURATOR_URL_SWITCH_FEATURE = FEATURE_FLAGS.configuratorUrlSwitch;
export const CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION_FEATURE = FEATURE_FLAGS.convertToCurrencyForMasterIntegration;
export const DISCOVERY_MODE_FEATURE = FEATURE_FLAGS.discoveryMode;
export const FILLED_TEXT_FEATURE = FEATURE_FLAGS.filledText;
export const INKSCAPE_IMAGE_CONVERSION_UPLOAD_FEATURE = FEATURE_FLAGS.iNKSCAPEIMAGECONVERSIONUPLOAD;
export const INTERFACE_PLUGINS_FEATURE = FEATURE_FLAGS.interfacePlugins;
export const JSON_PRODUCTS_IMPORT_FEATURE = FEATURE_FLAGS.jsonProductsImport;
export const MOQ_FEATURE = FEATURE_FLAGS.mOQ;
export const NEW_CONFIGURATOR_BACKOFFICE_FEATURE = FEATURE_FLAGS.newConfiguratorBackoffice;
export const NEW_CONFIGURATOR_UIENABLED_FEATURE = FEATURE_FLAGS.newConfiguratorUIEnabled;
export const NEW_CUSTOMIZER_MONOCHROME_UI_FEATURE = FEATURE_FLAGS.newCustomizerMonochromeUI;
export const ORDER_ERRORS_FEATURE = FEATURE_FLAGS.orderErrors;
export const PDF_TO_SVG_FEATURE = FEATURE_FLAGS.pDFTOSVG;
export const PREVIEW3DCAMERA_FEATURE = FEATURE_FLAGS.preview3DCamera;
export const PROTOTYPE_MODE_FEATURE = FEATURE_FLAGS.prototypeMode;
export const RATE_LIMIT_FEATURE = FEATURE_FLAGS.rateLimit;
export const SALES_CHANNELS_ON_BULK_FEATURE = FEATURE_FLAGS.salesChannelsOnBulk;
export const SHOPIFY_REDACT_PRODUCTS_FEATURE = FEATURE_FLAGS.shopifyRedactProducts;
export const STANDALONE_FEATURE = FEATURE_FLAGS.standalone;
export const STORAGE_FEATURE_FEATURE = FEATURE_FLAGS.storageFeature;
export const SVG_CLIP_ENABLED_FEATURE = FEATURE_FLAGS.svgClipEnabled;
export const SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED_FEATURE = FEATURE_FLAGS.svgConvertTextInOutlinesEnabled;
export const DESIGNWITHAIBACKOFFICE_FEATURE = FEATURE_FLAGS.designwithaibackoffice;
export const MINIMUM_ORDER_QUANTITY_PRICE_UI_FEATURE = FEATURE_FLAGS.minimumOrderQuantityPriceUi;
export const SWITCH_SALES_CHANNEL_FEATURE = FEATURE_FLAGS.switchSalesChannel;

// Feature flag names enum
export enum FeatureFlagNames {
  AISTUDIO_IN_PREVIEW = 'aIStudioInPreview',
  AI_EPS_TO_SVG = 'aIEPSToSvg',
  ACCESSIBILITY_WIDGET = 'accessibilityWidget',
  ADDITIONAL_ATTRIBUTES = 'additionalAttributes',
  AI_STUDIO3D = 'aiStudio3D',
  ALLOW_AITOOLS_FOR_TRIAL_USERS = 'allowAIToolsForTrialUsers',
  BACKGROUND_REMOVER_LEGACY_SELECTION = 'backgroundRemoverLegacySelection',
  BULK_IMPORT = 'bulkImport',
  BULK_UNIT_PRICE = 'bulkUnitPrice',
  CONFIGURATOR_URL_SWITCH = 'configuratorUrlSwitch',
  CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION = 'convertToCurrencyForMasterIntegration',
  DISCOVERY_MODE = 'discoveryMode',
  FILLED_TEXT = 'filledText',
  INKSCAPE_IMAGE_CONVERSION_UPLOAD = 'iNKSCAPEIMAGECONVERSIONUPLOAD',
  INTERFACE_PLUGINS = 'interfacePlugins',
  JSON_PRODUCTS_IMPORT = 'jsonProductsImport',
  MOQ = 'mOQ',
  NEW_CONFIGURATOR_BACKOFFICE = 'newConfiguratorBackoffice',
  NEW_CONFIGURATOR_UIENABLED = 'newConfiguratorUIEnabled',
  NEW_CUSTOMIZER_MONOCHROME_UI = 'newCustomizerMonochromeUI',
  ORDER_ERRORS = 'orderErrors',
  PDF_TO_SVG = 'pDFTOSVG',
  PREVIEW3DCAMERA = 'preview3DCamera',
  PROTOTYPE_MODE = 'prototypeMode',
  RATE_LIMIT = 'rateLimit',
  SALES_CHANNELS_ON_BULK = 'salesChannelsOnBulk',
  SHOPIFY_REDACT_PRODUCTS = 'shopifyRedactProducts',
  STANDALONE = 'standalone',
  STORAGE_FEATURE = 'storageFeature',
  SVG_CLIP_ENABLED = 'svgClipEnabled',
  SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED = 'svgConvertTextInOutlinesEnabled',
  DESIGNWITHAIBACKOFFICE = 'designwithaibackoffice',
  MINIMUM_ORDER_QUANTITY_PRICE_UI = 'minimumOrderQuantityPriceUi',
  SWITCH_SALES_CHANNEL = 'switchSalesChannel'
}

// Build-time feature flags metadata
export const FEATURE_FLAGS_METADATA = {
  generatedAt: '2026-06-08T11:07:13.238Z',
  totalFlags: 34,
  enabledFlags: 25,
  flagNames: ['AIStudioInPreview', 'AI_EPS_ToSvg', 'AccessibilityWidget', 'AdditionalAttributes', 'AiStudio3D', 'AllowAIToolsForTrialUsers', 'BackgroundRemoverLegacySelection', 'BulkImport', 'BulkUnitPrice', 'ConfiguratorUrlSwitch', 'ConvertToCurrencyForMasterIntegration', 'DiscoveryMode', 'FilledText', 'INKSCAPE_IMAGE_CONVERSION_UPLOAD', 'InterfacePlugins', 'JsonProductsImport', 'MOQ', 'NewConfiguratorBackoffice', 'NewConfiguratorUIEnabled', 'NewCustomizerMonochromeUI', 'OrderErrors', 'PDF_TO_SVG', 'Preview3DCamera', 'PrototypeMode', 'RateLimit', 'SalesChannelsOnBulk', 'ShopifyRedactProducts', 'Standalone', 'StorageFeature', 'SvgClipEnabled', 'SvgConvertTextInOutlinesEnabled', 'designwithaibackoffice', 'minimumOrderQuantityPriceUi', 'switchSalesChannel'] as const
} as const;
